import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_FieldLabel } from '../../labels/fieldLabel/S_FIeldLabel';
import { S_ColorPicker, S_ColorPickerProps } from '../../pickers/colorPicker/S_ColorPicker';

interface S_ColorFieldProps extends S_ColorPickerProps {
  labelText: string;
  disabled?: boolean;
  isRequired?: boolean;
}

export const S_ColorField = observer((props: S_ColorFieldProps): ReactElement => {
  return (
    <div>
      <S_FieldLabel
        isRequired={props.isRequired}
        text={props.labelText}
      />
      <S_ColorPicker {...props} />
    </div>
  );
});
